import { apiService } from '../../shared/services/apiService';
import { LoadedFile } from '../../shared/interfaces/LoadedFile';

type GetRegistrationLinkResponse = {
  url: string;
};

export const nutritionRegistrationService = {
  async getRegistrationLink(entityId: number) {
    const resp = await apiService.get<GetRegistrationLinkResponse>(
      `api/entity/${entityId}/settings/customer-setup/link`,
    );

    return resp.data;
  },

  async getRegistrationQrCode(entityId: number) {
    const resp = await apiService.get<LoadedFile>(
      `api/entity/${entityId}/settings/customer-setup/qr-code`,
    );

    return resp.data;
  },
};
